import React from 'react';

function Footer() {
    return (
        <footer className='App-footer'>
            <p>Сайт является развлекухой by givenys, (C) 2026 хз </p>
        </footer>
    );
}

export default Footer;
